/**
 * Utility to check if the current user has a specific permission.
 */
export const checkPermission = (permissionCode: string): boolean => {
  const userStr = localStorage.getItem('atelier_bassoum_user');
  if (!userStr) return false;

  try {
    const user = JSON.parse(userStr);
    
    // Superadmin has all permissions
    if (user.role === 'superadmin') return true;
    
    // Check if the code exists in the user's permissions array
    const permissions: string[] = user.permissions || [];
    return permissions.includes(permissionCode);
  } catch (err) {
    console.error("Error checking permissions:", err);
    return false;
  }
};

/**
 * Common permission constants to avoid typos
 */
export const PERMISSIONS = {
  DASH_ATELIER: 'DASH_ATELIER',
  CMD_CREER: 'CMD_CREER',
  VENTE_CREER: 'VENTE_CREER',
  CLIENT_VOIR: 'CLIENT_VOIR',
  STOCK_VOIR: 'STOCK_VOIR',
  STOCK_MODIFIER: 'STOCK_MODIFIER',
  PAIE_VOIR: 'PAIE_VOIR',
  CA_VOIR: 'CA_VOIR',
  USER_VOIR: 'USER_VOIR',
  USER_GERER: 'USER_GERER',
  EDIT_COMMANDE: 'EDIT_COMMANDE',
  DELETE_COMMANDE: 'DELETE_COMMANDE',
  MANAGE_SUPPLIERS: 'MANAGE_SUPPLIERS',
  EDIT_CLIENT: 'EDIT_CLIENT',
  DELETE_CLIENT: 'DELETE_CLIENT',
  DELETE_PAIE: 'DELETE_PAIE',
  CANCEL_COMMANDE: 'CANCEL_COMMANDE'
};
